/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React, { useState, useEffect } from "react";
import { style } from "../Report/styles";
import workpg from "../../Images/workpg.png";
import quotation from "../../Images/Quotation.png";
import call from "../../Images/call.png";
import { styles } from "../Subscription/styles";
import completed from "../../Images/completed.png";

import { FaPhone, FaFileAlt, FaHourglassHalf, FaCheck } from "react-icons/fa";

const Progress = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [backendInfo, setBackendInfo] = useState("");

  const steps = [
    { name: "Call Placed", icon: FaPhone, image: call },
    { name: "Quotation Review", icon: FaFileAlt, image: quotation },
    { name: "Job in Progress", icon: FaHourglassHalf, image: workpg },
    { name: "Project Completed", icon: FaCheck, image: completed },
  ];

  useEffect(() => {
    fetchBackendInfo();
  }, []);

  const fetchBackendInfo = async () => {
    const info = await new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            info: "Kitchen Installation",
            startDate: new Date("2024-12-24"),
            endDate: new Date("2024-12-30"),
            currentStep: 3,
          }),
        1000
      )
    );

    setBackendInfo(info.info);
    setStartDate(info.startDate);
    setEndDate(info.endDate);
    setCurrentStep(info.currentStep);
  };

  return (
    <>
      <div className="box-border bg-white  min-h-screen md:p-4">
        <div
          className="w-120 text-2xl pb-12  pt-20 ml-16 font-semibold text-navBg "
          style={styles.interText}
        >
          Job Progress
        </div>
        <div className=" flex flex-col items-center  justify-center px-4 md:px-8 lg:px-16 py-8">
          <div className="w-full max-w-screen-lg">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-8">
              {/* Service Type */}
              <div className="flex flex-col justify-center items-center p-4 border border-gray-700 border-opacity-50 rounded-lg w-full h-16">
                <h1 className="text-lg md:text-xl font-semibold mb-1">
                  Service Type
                </h1>
                <div className="text-base md:text-lg font-normal text-black">
                  {backendInfo}
                </div>
              </div>

              {/* Start Date */}
              <div className="flex flex-col justify-center items-center p-4 border border-gray-700 border-opacity-50 rounded-lg w-full h-16">
                <h1 className="text-lg md:text-xl font-semibold mb-1">
                  Start Date
                </h1>
                {startDate && (
                  <div className="text-base md:text-lg font-normal text-black">
                    {startDate
                      .toLocaleDateString("en-GB", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      .split("/")
                      .join("-")}
                  </div>
                )}
              </div>

              {/* End Date */}
              <div className="flex flex-col justify-center items-center p-4 border border-gray-700 border-opacity-50 rounded-lg w-full h-16">
                <h1 className="text-lg md:text-xl font-semibold mb-1">
                  End Date
                </h1>
                {endDate && (
                  <div className="text-base md:text-lg font-normal text-black">
                    {endDate
                      .toLocaleDateString("en-GB", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      .split("/")
                      .join("-")}
                  </div>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className="flex flex-col justify-center items-center p-4 border border-black rounded-lg w-full h-60"
                >
                  {index <= currentStep && (
                    <img
                      src={step.image}
                      alt={step.name.toLowerCase()}
                      className="w-full h-full object-cover rounded-lg"
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="relative mt-8 md:mt-20 w-full justify-center hidden md:flex md:gap-40">
              {steps.map((step, index) => {
                const Icon = step.icon;
                const isCompleted = index <= currentStep;
                return (
                  <div
                    key={index}
                    className="relative flex flex-col items-center step-item"
                  >
                    <div
                      className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full border-2 ${
                        isCompleted
                          ? "bg-navBg border-navBg text-white"
                          : "border-gray-400 text-gray-400"
                      }`}
                    >
                      <Icon size={14} />
                    </div>
                    <div
                      className={`text-center mt-8 md:mt-16 text-xs md:text-base ${
                        isCompleted ? "text-navBg" : "text-gray-400"
                      }`}
                    >
                      {step.name}
                    </div>
                    {index < steps.length - 1 && (
                      <div
                        className={`absolute top-1/2 left-full transform -translate-y-2 md:-translate-y-11 h-0.5 ${
                          index + 1 <= currentStep
                            ? "bg-navBg"
                            : "bg-none dashed-line"
                        }`}
                        style={{ width: "187px", md: "164px" }}
                      ></div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Progress;
